"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/native-browser.js
// module id = 1175
// module chunks = 0